/**
 * AI 주소 검토 클라이언트 래퍼.
 * Cloud Function `reviewAddress` 호출해서 손으로 쓴 주소 정정 결과를 받는다.
 */
import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export interface ReviewInput {
  rawAddress: string;
  refinedAddress?: string;
  school: string;
  gu?: string;
  dong?: string;
  buildingName?: string;
}

export interface ReviewFixed {
  address: string;
  type: "ROAD" | "PARCEL";
  lat: number;
  lng: number;
  confidence: "high";
  reasoning: string;
  original: string;
}

export interface ReviewCandidate {
  address: string;
  type: "ROAD" | "PARCEL";
  confidence: "medium" | "low";
  lat?: number;
  lng?: number;
  reasoning: string;
}

export interface ReviewResult {
  status: "ai_fixed" | "needs_review" | "failed";
  fixed?: ReviewFixed;
  candidates?: ReviewCandidate[];
  aiReasoning?: string;
  assumptions?: string[];
}

const _callable = httpsCallable<ReviewInput, ReviewResult>(functions, "reviewAddress");

export async function reviewAddressWithAi(input: ReviewInput): Promise<ReviewResult> {
  const res = await _callable(input);
  return res.data;
}
